import { CommonModule } from '@angular/common';
import {
  afterNextRender,
  Component,
  input,
  model,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Spinner } from '@malirang/front-share';

declare global {
  interface Window {
    nhn: any;
    husky: any;
    EZCreator: any;
    createSEditor2: any;
    oEditors: any[];
    onload: any;
    onloadSmartEditor: any;
    onloadSmartEditor2: any;
    onloadSmartEditor3: any;
    onloadSmartEditor4: any;
    onloadSmartEditor5: any;
    onloadSmartEditor6: any;
    onloadSmartEditor7: any;
  }
}

export const getEditorText = (oEditors: any, id: string = 'ir1') => {
  oEditors?.getById['ir1']?.exec('UPDATE_CONTENTS_FIELD', []);
  const content = (document.getElementById(id) as any).value;
  return content;
};

@Component({
  selector: 'app-smart-editor',
  templateUrl: './smart-editor.component.html',
  styleUrls: ['./smart-editor.component.css'],
  imports: [CommonModule, FormsModule, Spinner],
})
export class SmartEditorComponent {
  height = input<string>('450px');
  _config = input<any>({}, { alias: 'config' });
  config = signal<any>(null);

  id = input<string>('ir1');
  oEditors = model<any[]>([]);
  updateContent = input<string>('');
  loading = signal<boolean>(false);

  constructor() {
    afterNextRender(() => {
      if (!this._config()) {
        this.config.set({
          id: this.id(),
        });
      } else {
        this.config.set(this._config());
      }

      if (window['nhn']) {
        this.initEditor();
      } else {
        this.loadScript();
      }
    });
  }

  loadScript() {
    const url = '/se2/js/service/HuskyEZCreator.js';
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);

    script.onload = () => {
      this.initEditor();
    };
  }

  initEditor() {
    this.oEditors.set([]);

    window['nhn'].husky.EZCreator.createInIFrame({
      oAppRef: this.oEditors(),
      elPlaceHolder: 'ir1',
      sSkinURI: '/se2/SmartEditor2Skin.html',
      htParams: {
        bUseToolbar: true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)
        bUseVerticalResizer: true, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)
        bUseModeChanger: true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)
        //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)
        //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록
        fOnBeforeUnload: function () {
          // alert("완료!");
        },
        I18N_LOCALE: 'ko_KR',
      }, //boolean

      fCreator: 'createSEditor2',
    });
  }
}
